<template>
    <div>
        <div class="top-title-content">
            <span class="title">키오스크</span>
            <span class="txt">키오스크를 관리할 수 있습니다.</span>
        </div>

        <div class="com-tab">
            <button
                v-for="tab in TABS"
                :key="tab.key"
                :class="{ on: activeTab === tab.key }"
                @click="activeTab = tab.key"
            >
                {{ tab.label }}
            </button>
        </div>

        <component :is='tabComponent' />
    </div>
</template>

<script>
import HomeScreen from '@/components/setting/kiosk/HomeScreen.vue';
import TicketCategory from '@/components/setting/kiosk/TicketCategory.vue';
import DeviceScreen from '@/components/setting/kiosk/DeviceScreen.vue';
import PaymentNotificationRecipients from '@/components/setting/kiosk/PaymentNotificationRecipients.vue';

const TABS = [
    { key: 'home', label: '메인화면 설정' },
    { key: 'category', label: '이용권 설정' },
    { key: 'device', label: '기기설정' },
    { key: 'paymentNotification', label: '결제 알림' },
]

export default {
    name: 'SettingKiosk',
    data() {
        return {
            TABS,
            activeTab: "home",
        }
    },

    computed: {
        tabComponent: function () {
            return {
                home: HomeScreen,
                category: TicketCategory,
                device: DeviceScreen,
                paymentNotification: PaymentNotificationRecipients,
            }[this.activeTab]
        }
    },

    methods: {
    }
}
</script>

<style scoped>
.tab-content {
    display: flex;
    flex-direction: row;
    padding-top: 50px;
}
</style>
